<template>
  <div class="content">
    <h1 class="has-text-centered">Griechische Buchstaben</h1>
    <div class="box">
      <p>
        In der Elektrotechnik trifft man häufig auf Buchstaben aus dem griechischen Alphabet. (Beispiele: &pi; -> PI; &Tau; -> Zeitkonstante; &phi; -> Phasenverschiebung)
      </p>
      <p>
        <font-awesome-icon icon="arrow-circle-right" />
        <a href="https://de.wikipedia.org/wiki/Griechisches_Alphabet" target="_blank" class="pl-2">Wikipedia-Artikel zum griechischen Alphabet</a>
      </p>
      <div class="has-overflow-x-auto mb-3">
        <table class="table is-hoverable is-striped is-fullwidth">
          <thead>
            <tr>
              <th>Groß</th>
              <th>Klein</th>
              <th>Bezeichnung</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>&Alpha;</td>
              <td>&alpha;</td>
              <td>Alpha</td>
            </tr>
            <tr>
              <td>&Beta;</td>
              <td>&beta;</td>
              <td>Beta</td>
            </tr>
            <tr>
              <td>&Gamma;</td>
              <td>&gamma;</td>
              <td>Gamma</td>
            </tr>
            <tr>
              <td>&Delta;</td>
              <td>&delta;</td>
              <td>Delta</td>
            </tr>
            <tr>
              <td>&Epsilon;</td>
              <td>&epsilon;</td>
              <td>Epsilon</td>
            </tr>
            <tr>
              <td>&Zeta;</td>
              <td>&zeta;</td>
              <td>Zeta</td>
            </tr>
            <tr>
              <td>&Eta;</td>
              <td>&eta;</td>
              <td>Eta</td>
            </tr>
            <tr>
              <td>&Theta;</td>
              <td>&theta;</td>
              <td>Theta</td>
            </tr>
            <tr>
              <td>&Iota;</td>
              <td>&iota;</td>
              <td>Iota</td>
            </tr>
            <tr>
              <td>&Kappa;</td>
              <td>&kappa;</td>
              <td>Kappa</td>
            </tr>
            <tr>
              <td>&Lambda;</td>
              <td>&lambda;</td>
              <td>Lambda</td>
            </tr>
            <tr>
              <td>&Mu;</td>
              <td>&mu;</td>
              <td>My</td>
            </tr>
            <tr>
              <td>&Nu;</td>
              <td>&nu;</td>
              <td>Ny</td>
            </tr>
            <tr>
              <td>&Xi;</td>
              <td>&xi;</td>
              <td>Xi</td>
            </tr>
            <tr>
              <td>&Omicron;</td>
              <td>&omicron;</td>
              <td>Omikron</td>
            </tr>
            <tr>
              <td>&Pi;</td>
              <td>&pi;</td>
              <td>Pi</td>
            </tr>
            <tr>
              <td>&Rho;</td>
              <td>&rho;</td>
              <td>Rho</td>
            </tr>
            <tr>
              <td>&Sigma;</td>
              <td>&sigma;</td>
              <td>Sigma</td>
            </tr>
            <tr>
              <td>&Tau;</td>
              <td>&tau;</td>
              <td>Tau</td>
            </tr>
            <tr>
              <td>&Upsilon;</td>
              <td>&upsilon;</td>
              <td>Ypsilon</td>
            </tr>
            <tr>
              <td>&Phi;</td>
              <td>&phi;</td>
              <td>Phi</td>
            </tr>
            <tr>
              <td>&Chi;</td>
              <td>&chi;</td>
              <td>Chi</td>
            </tr>
            <tr>
              <td>&Psi;</td>
              <td>&psi;</td>
              <td>Psi</td>
            </tr>
            <tr>
              <td>&Omega;</td>
              <td>&omega;</td>
              <td>Omega</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tables-greek-alphabet',
  metaInfo: {
    title: 'Griechisches Alphabet Tabelle | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'In der Elektrotechnik bzw. Physik werden gerne griechische Buchstaben verwendet. Hier findest du eine Liste aller Buchstaben.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
